import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import playBtn from 'images/play-btn.svg';
import trendLogo from 'images/trend-logo-black.svg';
import soonaLogo from 'images/soona-logo.svg';
import videoThumb from 'images/video-thumb.png';
import { ReactComponent as CloseIcon } from 'images/close-x.svg';
import {
  alternateSignUpButtonLabel,
  alternateSignUpUrl,
  alternateSignUpVideo,
  isAlternateSignUpEnabled,
} from 'constants/alternateSignUp';
import './RedirectToSoonaBanner.less';

/**
 * RedirectToSoonaBanner
 * Prompts brands to move the campaign to soona when alternate sign-up is enabled.
 *
 * @type {React.FC}
 */
const RedirectToSoonaBanner = () => {
  const dialogVideoRef = useRef(null);
  const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);

  useEffect(() => {
    if (!isVideoDialogOpen && dialogVideoRef.current) {
      dialogVideoRef.current.pause();
      dialogVideoRef.current.currentTime = 0;
    }
  }, [isVideoDialogOpen]);

  if (!isAlternateSignUpEnabled) {
    return null;
  }

  const openVideoDialog = () => {
    if (!alternateSignUpVideo) {
      return;
    }
    setIsVideoDialogOpen(true);
  };

  const closeVideoDialog = () => {
    setIsVideoDialogOpen(false);
  };

  return (
    <>
      <aside className="alternate-sign-up-banner">
        {alternateSignUpVideo && (
          <button
            type="button"
            className="u-button-reset alternate-sign-up-banner__media"
            onClick={openVideoDialog}
            aria-label="Play video"
          >
            <img alt="video thumbnail" src={videoThumb} width="106" height="90" />
            <span className="alternate-sign-up-banner__play" aria-hidden>
              <img src={playBtn} alt="" />
            </span>
          </button>
        )}
        <div className="alternate-sign-up-banner__content">
          <div className="alternate-sign-up-banner__logos">
            <img className="alternate-sign-up-banner__trend" src={trendLogo} alt="Trend" />
            <span className="alternate-sign-up-banner__arrow" aria-hidden>
              →
            </span>
            <img className="alternate-sign-up-banner__soona" src={soonaLogo} alt="soona" />
          </div>
          <p className="alternate-sign-up-banner__title">
            Trend is winding down. The future is on soona.
          </p>
          <p className="alternate-sign-up-banner__body">
            We’re transitioning Trend to soona over the coming months. Your existing campaigns will
            continue running as usual, but we recommend creating all new campaigns on soona to
            access more creators, studio photography and video, and new tools.
          </p>
        </div>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          className="alternate-sign-up-banner__cta"
          href={alternateSignUpUrl}
          target="_blank"
          rel="noopener"
        >
          {alternateSignUpButtonLabel}
        </a>
      </aside>

      <Modal
        visible={isVideoDialogOpen}
        onCancel={closeVideoDialog}
        footer={null}
        closable={false}
        destroyOnClose
        centered
        width={1024}
        height={720}
        wrapClassName="alternate-sign-up-video-dialog"
      >
        <button
          type="button"
          className="u-button-reset alternate-sign-up-video-dialog__close"
          onClick={closeVideoDialog}
          aria-label="Close video"
        >
          <CloseIcon />
        </button>
        {alternateSignUpVideo && (
          <iframe
            src={alternateSignUpVideo}
            height="600"
            width="100%"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            title="NICCOLO - Animation Short Film 2025 - GOBELINS"
          />
        )}
      </Modal>
    </>
  );
};

export default RedirectToSoonaBanner;
